import CommentList from '_modules/comment/views/CommentList.vue';
import Comments from './Root.vue';

export default {
  path: 'comentario',
  name: 'comment',
  component: Comments,
  redirect: '/comentario/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-comment-list',
      component: CommentList,
    },
  ],
};
